import React from "react";

export const Header = ({ data }) => {
  return (
    <header id="header">
      <div className="hero-bg"></div>
      <div className="hero-grid"></div>
      <div className="hero-glow"></div>

      <div className="hero-content">
        <span className="hero-eyebrow">Digital Product Studio &middot; Cancún, México</span>

        <h1 className="hero-title">
          We Build Digital
          <span className="hero-title-accent">Products That Matter</span>
        </h1>

        <p className="hero-subtitle">
          {data
            ? data.paragraph
            : "Mindware designs and builds software end-to-end — from strategy and UX to development and launch."}
        </p>

        <div className="hero-actions">
          <a href="#products" className="btn-primary-mw page-scroll">
            See Our Products <i className="fa fa-arrow-right"></i>
          </a>
          <a href="#contact" className="btn-outline-mw page-scroll">
            Get in Touch
          </a>
        </div>

        <div className="hero-badges">
          <span className="hero-badge">
            <i className="fa fa-check-circle"></i> 5 Live Products
          </span>
          <span className="hero-badge">
            <i className="fa fa-map-marker"></i> Based in Cancún
          </span>
          <span className="hero-badge">
            <i className="fa fa-code"></i> End-to-end Studio
          </span>
        </div>
      </div>
    </header>
  );
};
